import { createSlice } from '@reduxjs/toolkit';
import { TPromoSearchTypes } from 'shared/types/promoSearchTypes';

const name = 'promoSearchTypes';

export const promoSearchTypesSlice = createSlice<TPromoSearchTypes | null, {}, typeof name>({
  name,
  initialState: null,
  reducers: {},
});

export const { reducer: promoSearchTypesReducer, name: promoSearchTypesReducerName } = promoSearchTypesSlice;
